import React, { useContext } from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import { ReactComponent as DocumentSvg } from "../../../../assets/chat/nda-document.svg";
import Button from "../../Button";
import AppContext from "../../../../AppContext";

const _prefix = "chat-tendering__nda-sent";

const NDASent = ({ tenderingId }) => {
  const { tenderingViewNDA } = useContext(AppContext);

  const handleClick = () => {
    tenderingViewNDA(tenderingId);
  };

  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <div className={`${_prefix}__desc`}>
          <DocumentSvg width={24} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span className={`${_prefix}__desc__name`}>
              You are invited to next the process
            </span>
            <span className={`${_prefix}__desc__name`}>
              Please accept NDA to access our files
            </span>
          </div>
        </div>
        <Button label={"View NDA"} size="small" onClick={handleClick} />
      </div>
    </MessageContainer>
  );
};

NDASent.propTypes = {};

export default NDASent;
